<template>
    <div class="cookie-panel" v-show="shouldShowBanner">
        <Transition appear name="cookie-panel-overlay-toggle">
            <div class="cookie-panel__overlay" v-if="shouldShowBanner"></div>
        </Transition>
        <Transition appear name="cookie-panel-toggle">
            <div class="cookie-panel__content" v-if="shouldShowBanner">
                <slot></slot>
                <button class="cookie-panel__button" @click="hideBanner">Close</button>
            </div>
        </Transition>
    </div>
</template>

<script setup>
import {useCookieMessage} from "../composables/useCookieMessage";
import {onMounted, watchEffect} from "vue";

const {shouldShowBanner,hideBanner} = useCookieMessage();


onMounted(()=>{
	watchEffect(()=>{
		document.body.classList.toggle('is-locked',shouldShowBanner.value);
	})
})



</script>

<style scoped>


.cookie-panel-toggle-enter-from, .cookie-panel-toggle-leave-to {
	transform: translateX(-100%);
}

.cookie-panel-toggle-enter-active, .cookie-panel-toggle-leave-active {
	transition: transform 0.2s;
}

.cookie-panel-toggle-enter-to, .cookie-panel-toggle-leave-from {
	transform: translateX(0);
}

.cookie-panel-overlay-toggle-enter-from,.cookie-panel-overlay-toggle-leave-to {
	opacity: 0;
}

.cookie-panel-overlay-toggle-enter-active, .cookie-panel-overlay-toggle-leave-active {
	transition: opacity 0.8s;
}

.cookie-panel-overlay-toggle-enter-to, .cookie-panel-overlay-toggle-leave-from {
	opacity: 0.8;
}

</style>
